/** @jsx jsx */

import { jsx, Heading } from 'theme-ui'

const StyledHeading = ({ children, ...props }) => {
  return <Heading {...props}>{children}</Heading>
}

export default StyledHeading
